/**
 * Modular What's New entries for the "smartFilter" module: AI natural-language filter on management lists. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const smartFilterEntries = [
  {
    id: 'smart-list-filter-2026-10',
    module: 'smartFilter',
    routes: ['ManagementListScreen'],
    date: '2026-10-21',
    version: '4.15.1',
    global: true,
    type: 'feature',
    title: {
      en: "✨ Just type what you are looking for",
      hu: "✨ Írd be, mit keresel – a lista megérti",
      de: "✨ Einfach eintippen, was Sie suchen",
      cn: "✨ 直接输入你要找的内容",
      ro: "✨ Scrie pur și simplu ce cauți",
      svn: "✨ Preprosto vpišite, kaj iščete",
    },
    body: {
      en: "Above the management lists there is now a prompt: type something like “customers who have not ordered for 3 months” and Happy AI turns it into filters. You see how it understood you, the conditions as chips and the number of hits, and one tap clears it. It works on the lists the backend can interpret, so there is no need to set filters one by one.",
      hu: "A vezetői listák fölött mostantól egy beviteli sáv van: írd be például, hogy „3 hónapja nem rendelő ügyfelek”, és a Happy AI szűrőkké alakítja. Látod, hogyan értett meg, a feltételeket címkékként és a találatok számát, egy koppintás pedig törli. Azokon a listákon működik, amelyeket a háttérrendszer értelmezni tud, így nem kell egyenként beállítani a szűrőket.",
      de: "Über den Management-Listen gibt es jetzt eine Eingabezeile: Tippen Sie z. B. „Kunden, die seit 3 Monaten nicht bestellt haben“, und Happy AI macht daraus Filter. Sie sehen, wie die Eingabe verstanden wurde, die Bedingungen als Chips und die Trefferzahl; ein Tipp setzt alles zurück. Es funktioniert in den Listen, die das Backend interpretieren kann – Filter müssen nicht mehr einzeln gesetzt werden.",
      cn: "管理列表上方现在有一个输入栏：输入例如“3 个月没下单的客户”，Happy AI 会把它转换成筛选条件。你可以看到它如何理解你的意思、以标签显示的条件和命中数量，轻点一下即可清除。它适用于后端能够解析的列表，无需再逐项设置筛选。",
      ro: "Deasupra listelor de management există acum un câmp de text: scrie, de exemplu, „clienți care nu au comandat de 3 luni” și Happy AI îl transformă în filtre. Vezi cum a înțeles, condițiile ca etichete și numărul de rezultate, iar o atingere le șterge. Funcționează pe listele pe care backendul le poate interpreta, deci nu mai trebuie să setezi filtrele unul câte unul.",
      svn: "Nad seznami upravljanja je zdaj vnosno polje: vpišite na primer »stranke, ki že 3 mesece niso naročile«, Happy AI pa to pretvori v filtre. Vidite, kako vas je razumel, pogoje kot oznake in število zadetkov, en dotik pa vse počisti. Deluje na seznamih, ki jih zaledje zna razumeti, zato filtrov ni treba nastavljati enega za drugim.",
    },
  },
];

export default smartFilterEntries;
